import React from'react';import PropTypes from'prop-types';import {Tooltip}from'@manulife/mux';import RealmSpecific from'../RealmSpecific/RealmSpecific.js';import useRichIntl from'../../hooks/useRichIntl.js';var TooltipComponent = function TooltipComponent(_ref) {
  var contentID = _ref.contentID,
    hideFor = _ref.hideFor;
  var richIntl = useRichIntl();
  return /*#__PURE__*/React.createElement(RealmSpecific, {
    hideFor: hideFor
  }, /*#__PURE__*/React.createElement(Tooltip, {
    bubbleWidth: 255,
    content: richIntl.formatMessage({
      id: contentID
    })
  }));
};
process.env.NODE_ENV !== "production" ? TooltipComponent.propTypes = {
  contentID: PropTypes.string.isRequired,
  hideFor: PropTypes.array
} : void 0;
TooltipComponent.defaultProps = {
  hideFor: []
};
var TooltipComponent$1 = TooltipComponent;export{TooltipComponent$1 as default};